// This is global variable to store the Auth0 getAccessTokenSilently function.
// Auth0 functions are only available within the React component tree, so we need to store it here to use it in the apiSlice.
let getAccessTokenSilently: (() => Promise<string>) | null = null;

export const sec = {
  getAccessTokenSilently: (): Promise<string> => {
    if (!getAccessTokenSilently) {
      return Promise.reject(new Error("Auth0 token getter not initialized"));
    }
    return getAccessTokenSilently();
  },
  setAccessTokenSilently: (func: () => Promise<string>) => {
    getAccessTokenSilently = func;
  },
};
